import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  getOrganizationIdLocalStorage,
  getLanguageLocalStorage,
} from '../../../../helpers/localStorage';
import { ErrorChecker } from '../../../../stores/helpers/ErrorChecker';

import type { getAllDevicesDTO } from '../../dto/getAllDevices.dto';
import type { ThunkConfig } from '../../../../stores/types';

export const getAllDevicesAsync = createAsyncThunk<getAllDevicesDTO, void, ThunkConfig>(
  'devices/organization',
  async (_, { rejectWithValue }) => {
    const organizationId = getOrganizationIdLocalStorage();
    const language = getLanguageLocalStorage();

    try {
      const { data } = await axios.get<{ data: getAllDevicesDTO }>(
        `/private/organizations/${organizationId}/devices`,
        {
          headers: {
            'Accept-Language': language,
          },
        },
      );

      return data.data;
    } catch (err) {
      return rejectWithValue(ErrorChecker(err));
    }
  },
);
